<template>
    <input
      type="text"
      :value="rawValue"
      @change="handleChange"
      @blur="formatCurrency"
      :placeholder="placeholder"
      :class="inputClass"
      :style="inputStyle"
      @input="onInput"
    />
  </template>
  
  <script>
 
  export default {
    props: {
      value: {
        type: Number,
        default: 0,
      },
      placeholder: {
        type: String,
        default: "Enter amount",
      },
      inputClass: {
        type: String,
        default: "form-control ",
      },
      inputStyle: {
        type: String,
        default: " ",
      },
      handleInput: {
          type: Function,
          default: null
      },
      index: {
        type: Number,
        default: -1
      }
    },

    data() {
      return {
        rawValue: this.formatAsCurrency(this.value), // Store displayed value separately
      };
    },
    methods: {
      formatAsCurrency(value) {
        if (value === null || value === undefined || isNaN(value)) return "";
        return new Intl.NumberFormat("en-US", {
          style: "currency",
          currency: "USD",
        }).format(value);
      },
  
      onInput(event) {
       
        let rawValue = event.target.value.replace(/[^0-9.]/g, ""); // Remove non-numeric characters
        this.rawValue = rawValue;
      
        //console.log("onInput triggered", rawValue);
        if (this.handleInput) {
          this.handleInput(rawValue);
        }
      },
 
      handleChange(event) {
        let rawValue = event.target.value.replace(/[^0-9.]/g, ""); // Remove non-numeric characters
        if (rawValue.includes(".")) {
          const parts = rawValue.split(".");
          rawValue = parts[0] + "." + (parts[1] ? parts[1].slice(0, 2) : "");
        }


        this.rawValue = rawValue; // Display raw input while typing
      
        if(this.index >= 0) {
          //console.log("index", this.index);
          this.$emit("updateAmount", parseFloat(rawValue) || 0, this.index); // Emit value to parent
        }else{
          this.$emit("update:value", parseFloat(rawValue) || 0); // Emit value to parent
        }
        //this.$emit("updateAmount", parseFloat(rawValue) || 0); // Emit value to parent
       
      },
  
      formatCurrency() {
        this.rawValue = this.formatAsCurrency(this.value); // Format when losing focus
      },
    },
    watch: {
      value(newValue) {
        //console.log("WATCH TRIGGERED:", newValue);
        this.rawValue = this.formatAsCurrency(newValue); // Update rawValue only when `value` changes from parent
      },
    },
  };
  </script>
  